// core
import {
  Component, OnInit, Input, Inject
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';

// services
import { RaptorDataService } from '@campfire-nx/raptor/lib/services/raptor-data.service';
import { RaptorStepService } from '@campfire-nx/raptor/lib/services/raptor-step.service';
import { RaptorAnalyticsService } from '@campfire-nx/raptor/lib/services/raptor-analytics.service';
import { RaptorStepDataService } from '@campfire-nx/raptor/lib/services/raptor-step-data.service';
import { RaptorFormService } from '@campfire-nx/raptor/lib/services/raptor-form.service';

@Component({
  selector: 'open-raptor-page-collinson-covers',
  templateUrl: './raptor-page-collinson-covers.component.html',
  styleUrls: ['./raptor-page-collinson-covers.component.scss']
})
export class RaptorPageCollinsonCoversComponent implements OnInit {
  @Input() formData: any;
  @Input() form!: FormGroup;

  marketingInfo!: any;
  windowScrollEvent!: any;
  windowResizeEvent!: any;
  priceScroll!: any;
  currency!: string;
  public stylesheet: SafeHtml = '';

  layoutSettings: any = {};
  frequencyControl!: any;
  frequencySwitchQuestion!: any;
  coverLevelQuestion!: any;
  coverLevelControl: any;
  coverTypeControl: any;
  covers!: Array<any>; // old covers object
  cover!: any; // new cover object to render
  coverLevel!: any;
  coverType!: any;
  disclaimers?: Array<any>;
  includedExtrasDisclaimers?: Array<any>;
  emailQuote = {
    layout: null,
    heading: 'Email my quote',
    settings: {
      style: 'link',
      action: 'email_quote',
      action_details: null
    },
    component: 'cta'
  };

  constructor(
    public raptorStepService: RaptorStepService,
    private raptorAnalyticsService: RaptorAnalyticsService,
    private raptorStepDataService: RaptorStepDataService,
    private raptorDataService: RaptorDataService,
    public raptorFormService: RaptorFormService,
    private partnerBrandService: PartnerBrandService,
    @Inject('environment') private environment: any,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.layoutSettings = this.formData.settings || {};
    this.coverLevelControl = this.form.get('cover_level');
    this.coverTypeControl = this.form.get('cover_type');
    this.frequencyControl = this.form.get('frequency');
    this.coverLevel = this.formData.data.cover_level;
    this.coverType = this.formData.data.cover_type;
    this.filterCovers();
    this.getProductBackground();
    this.currency = this.partnerBrandService.getCurrencySymbol();
    this.emailQuote.settings.action_details = this.formData.actions.email_quote;

    this.formData.sections.forEach((section: any) => {
      if (section.elements && section.elements.length) {
        section.elements.forEach((question: any) => {
          if (question.key === 'cover_level') {
            this.coverLevelQuestion = question;
            this.coverLevelQuestion.settings.updateOnChange = false;
          }
          if (question.key === 'frequency') {
            const yearlySaving = this.getYearlyCoverSavings(this.cover);

            this.frequencySwitchQuestion = question;
            this.frequencySwitchQuestion.settings.style = 'slide-toggle';
            this.frequencySwitchQuestion.settings.size = 'large';
            this.frequencySwitchQuestion.settings.align = 'center';
            this.frequencySwitchQuestion.prompt = '';
            this.frequencySwitchQuestion.settings.choices.forEach((choice: any) => {
              if (choice.value === 'U') {
                choice.label += ` (${Math.floor(yearlySaving.amount) > 0 ? '-' : ''}${yearlySaving.currency}${Math.floor(yearlySaving.amount)})`;
              }
            });
          }
        });
      }
    });

    if (this.formData.settings.marketing) {
      this.marketingInfo = this.formData.settings.marketing[this.coverType] || this.formData.settings.marketing.default;
    }
  }

  ngAfterViewInit(): void {
    this.windowScrollEvent = window.addEventListener('scroll', this.pinCovers);
    this.windowResizeEvent = window.addEventListener('resize', this.pinCovers);
  }

  ngOnDestroy(): void {
    const priceContainer = document.getElementsByClassName('raptor-page-price-container')[0];
    if (this.windowScrollEvent) {
      this.windowScrollEvent.removeListener('scroll', this.pinCovers);
    }
    if (this.windowResizeEvent) {
      this.windowScrollEvent.removeListener('resize', this.pinCovers);
    }
    if (this.priceScroll) {
      priceContainer.removeEventListener('scroll', this.pinCovers);
    }
  }

  get frequency() {
    return this.frequencyControl.value;
  }

  filterCovers() {
    const covers = this.formData.covers.filter((cover: any) => cover.cover.cover_type === this.formData.data.cover_type);
    this.cover = covers[0];
  }

  selectCover(cover: any) {
    if (cover && cover.cover) {
      this.coverLevelControl.setValue(cover.cover.cover_level, { emitEvent: false });
      setTimeout(() => {
        const form = document.getElementById('coverSubmit');
        form?.click();
      }, 500);
    }
  }

  getCoverPrice(cover: any, priceFrequency?: string): any {
    // the covers object can change, so get the latest price
    const formData = this.raptorStepDataService.get();
    const updatedCover = formData.covers.find((item: any) => item.cover.product_slug === cover.cover.product_slug &&
        item.cover.cover_type === cover.cover.cover_type &&
        item.cover.cover_level === cover.cover.cover_level);

    const formValues = this.form.value;
    const price = {
      currency: this.currency,
      amount: 0,
      frequency: 'month'
    };
    let frequency = priceFrequency || formValues.frequency || formData.data.frequency;
    let premiumAttr = 'payable';

    if (!frequency) {
      frequency = 'M';
    }

    if (frequency === 'U') {
      price.frequency = 'year';
      premiumAttr = 'payable';
    }
    if (frequency === 'M') {
      price.frequency = 'month';
      premiumAttr = 'payable_monthly';
    }
    if (this.layoutSettings.premium_attribute === 'payable') {
      price.frequency = 'year';
      premiumAttr = 'payable';
    }

    if (updatedCover && updatedCover.premium) {
      price.amount = updatedCover.premium[frequency] && updatedCover.premium[frequency][premiumAttr];
    }

    return price;
  }

  getYearlyCoverPrice(cover: any): any {
    // the covers object can change, so get the latest price
    const formData = this.raptorStepDataService.get();
    const updatedCover = formData.covers.find((item: any) => item.cover.product_slug === cover.cover.product_slug &&
        item.cover.cover_type === cover.cover.cover_type &&
        item.cover.cover_level === cover.cover.cover_level);
    const price = {
      currency: this.currency,
      amount: 0,
      frequency: 'year'
    };

    price.amount = updatedCover.premium.U && updatedCover.premium.U.payable;
    return price;
  }

  getYearlyCoverSavings(cover: any) {
    const monthlyPrice = this.getCoverPrice(cover, 'M');
    const yearlyPrice = this.getYearlyCoverPrice(cover);
    const saving: number = (monthlyPrice.amount * 12) - yearlyPrice.amount;

    return {
      amount: Math.floor(saving),
      frequency: null,
      currency: this.currency
    };
  }

  getCoverInfo(cover: any, property: string): any {
    let coverInfo!: any;
    let info = '';

    if (
      this.formData.settings.details &&
      this.formData.settings.details[cover.cover.cover_type] &&
      this.formData.settings.details[cover.cover.cover_type][cover.cover.cover_level]
    ) {
      coverInfo = this.formData.settings.details[cover.cover.cover_type][cover.cover.cover_level];
    }

    if (coverInfo && coverInfo[property]) {
      info = coverInfo[property];
    }
    return info;
  }

  getBanners(covers: any) {
    this.disclaimers = this.raptorDataService.mapBannerDisclaimers(covers);
  }

  getPolicyArrangementBannerDisclaimer(cover: any, disclaimers: any): any {
    const formData = this.raptorStepDataService.get();
    const updatedCover = formData.covers.find((item: any) => item.cover.product_slug === cover.cover.product_slug &&
        item.cover.cover_type === cover.cover.cover_type &&
        item.cover.cover_level === cover.cover.cover_level);
    const formValues = this.form.value;
    const frequency = formValues.frequency || formData.data.frequency;
    const banner = this.raptorDataService.getArrangementFeeBanner(updatedCover.premium, disclaimers as [], frequency, true);

    // set disclaimers in the footer
    this.includedExtrasDisclaimers = this.raptorDataService.getIncludedExtrasDisclaimers(updatedCover.premium[frequency].extras);

    return banner;
  }

  getTagLabel(banner: any) {
    return this.raptorDataService.mapBannerTag(banner, this.disclaimers);
  }

  openPdsDocument(url: string) {
    this.raptorAnalyticsService.trackAdditionalEvents('select-option', 'pds');
    window.open(`${this.environment.apiEndpoint}${url}`, '_blank');
  }

  pinCovers() {
    const coverPanel = document.getElementsByClassName('raptor-page-price-panel');
    const highlightContainer = document.getElementsByClassName('raptor-page-price-highlight');
    let containers: any;
    const controls = document.getElementsByClassName('carousel-controls');
    let carouselControls: any;
    let containerPosition: any;

    if (highlightContainer && highlightContainer.length) {
      containers = Array.from(highlightContainer);
      containerPosition = highlightContainer[0].getBoundingClientRect();
    }
    if (controls && controls.length > 1) {
      carouselControls = controls[1];
    }

    if (containers && containers.length) {
      if (containerPosition && containerPosition.top < 0) {
        containers.forEach((element: any, index: number) => {
          let coverPanelDimensions: any;
          let containerDimensions: any;
          let panel: any;
          let panelDimensions: any;
          let panelContiner: any;

          if (coverPanel[index]) {
            coverPanelDimensions = coverPanel[index].getBoundingClientRect();
          }
          if (highlightContainer[index]) {
            containerDimensions = highlightContainer[index].getBoundingClientRect();
          }
          if (highlightContainer[index]) {
            panel = Array.from(highlightContainer[index].getElementsByClassName('raptor-page-price-highlight-panel') as HTMLCollectionOf<HTMLElement>)[0];
          }
          if (panel) {
            panelDimensions = panel.getBoundingClientRect();
          }
          panelContiner = element as HTMLElement;

          if (containerPosition.top < -coverPanelDimensions.height + panelDimensions.height + 2) {
            // stick the price panel to the bottom of the cover panel
            element.classList.add('fixed');
            if (carouselControls) {
              carouselControls.classList.add('fixed');
            }
            panelContiner.style.paddingTop = `${panelDimensions.height}px`;
            panel.style.top = `${coverPanelDimensions.top + coverPanelDimensions.height - panelDimensions.height - 2}px`;
            panel.style.left = `${containerDimensions.left}px`;
            panel.style.right = `${containerDimensions.right}px`;
            panel.style.width = `${containerDimensions.width}px`;
          } else {
            element.classList.add('fixed');
            if (carouselControls) {
              carouselControls.classList.add('fixed');
            }
            panelContiner.style.paddingTop = `${panelDimensions.height}px`;
            panel.style.top = '0px';
            panel.style.left = `${containerDimensions.left}px`;
            panel.style.right = `${containerDimensions.right}px`;
            panel.style.width = `${containerDimensions.width}px`;
          }
        });
      } else {
        containers.forEach((element: any, index: number) => {
          let panel: any;
          const panelContiner = element as HTMLElement;

          if (highlightContainer[index]) {
            panel = Array.from(highlightContainer[index].getElementsByClassName('raptor-page-price-highlight-panel') as HTMLCollectionOf<HTMLElement>)[0];
          }

          element.classList.remove('fixed');
          if (carouselControls) {
            carouselControls.classList.remove('fixed');
          }
          if (panelContiner) {
            panelContiner.style.paddingTop = '0px';
          }
          if (panel) {
            panel.style.left = '0px';
            panel.style.right = '0px';
            panel.style.width = 'auto';
          }
        });
      }
    }
  }

  getProductBackground() {
    if (this.formData.data && this.formData.data.cover_type) {
      this.updateStyle(this.formData.data.cover_type);
    }
  }

  updateStyle(coverType: String) {
    this.stylesheet = this.domSanitizer
      .bypassSecurityTrustHtml(
        `<style>
          .raptor-page-container.raptor-page-container {
            background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(255, 255, 255, 0.00) 100%), url("/assets/partners/sosure/images/So-sure_${coverType}_image_desktop.webp");
          
            @media screen and (max-width: 639px) {
              background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(255, 255, 255, 0.00) 100%), url("/assets/partners/sosure/images/So-sure_${coverType}_image_tablet.webp");
            }
          
            @media screen and (max-width: 479px) {
              background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(255, 255, 255, 0.00) 100%), url("/assets/partners/sosure/images/So-sure_${coverType}_image_mobile.webp");
            }
          }
        </style>`
      );
  }
}
